<lib-app-skeleton
  [displayedApp]="displayedApp"
  [urlRedirectionApp]="urlRedirectionApp"
  [logoRoute]=""
  [nameRoute]=""
  [appName]="appName"
  [userFirstname]="firstname"
  [userLastname]="lastname"
  [menu]="menu"
  [onlySideMenuIcon]="onlySideMenuIcon"
  [version]="version"
  (onLogoutClick)="onLogout()"
  [legalMentionRouterLink]="'mentions-legales'"
>
</lib-app-skeleton>

<app-progress-spinner></app-progress-spinner>
